<app-sprintpay-footer>
    <app-footer-accordion [displayHandler]="!!dataSource.length">
        <ng-container header>
            <div class="table-container d-flex w-100 align-items-center">
                <app-footer-table
                    [dataSource]="dataSource"
                    [displayedColumns]="displayedColumns"
                    [columns]="columns"
                    [url]="'facility-information'"
                >
                </app-footer-table>
            </div>
        </ng-container>
    </app-footer-accordion>
</app-sprintpay-footer>
